import { ProgressBar } from '@/shared'

export const ImportProgress = ({ percents, label }: { percents: string; label: string | null }) => (
    <div style={{ width: '100%' }}>
        <ProgressBar percents={percents} label={label || 'Идет загрузка файла'} size='large' />
    </div>
)
